import { render, staticRenderFns } from "./mutasiJabatan.vue?vue&type=template&id=f39b8ca8"
import script from "./mutasiJabatan.vue?vue&type=script&lang=js"
export * from "./mutasiJabatan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports